import { USER_ROLES } from "@nlc/shared-types";
import { useLocation } from "@tanstack/react-router";

import { useUser } from "@/hooks/useUser";
import { useWhitelabel } from "@/hooks/useWhitelabel";

export function useIsWhitelabelOwner(): boolean {
  const { isWhitelabel } = useWhitelabel();
  const { data: user } = useUser();

  return Boolean(isWhitelabel) && user?.user.roleName === USER_ROLES.OWNER;
}

export function useIsWhitelabelDashboard(): boolean {
  const isWhitelabelOwner = useIsWhitelabelOwner();
  const { pathname } = useLocation();

  return isWhitelabelOwner && pathname.startsWith("/whitelabel/dashboard");
}
